module.exports = __webpack_public_path__ + "static/media/diamond.a5654b42.png";